// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kPAHdXg1ALlyZ8giDvUK{flex-direction:column;gap:30px;margin-bottom:30px;display:flex}.iLx5GDIYQmlY4XFU2sTE{width:100%}.Ny_XOn8hMsssAhUW55jt{--dropdown-checked-margin-left:5px}.lXxevrSI9GIcN9hFeRXq{grid-template-columns:1fr var(--titled-row-action-width,190px)}.CjGZhXpbGHwAb5YgkF5j{grid-template-columns:160px 1fr}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `kPAHdXg1ALlyZ8giDvUK`,
	"select": `iLx5GDIYQmlY4XFU2sTE`,
	"dropdown": `Ny_XOn8hMsssAhUW55jt`,
	"ticketOwnerRow": `lXxevrSI9GIcN9hFeRXq`,
	"autoAssignRow": `CjGZhXpbGHwAb5YgkF5j`
};
export default ___CSS_LOADER_EXPORT___;
